import images from 'assets/images/images'
import CountdownTimer from 'components/CountdownTimer'
import Button from 'components/form-elements/buttons/Button'
import { useRequest } from 'hooks/useRequest'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useToast from 'hooks/useToast';
import { setTimer } from 'redux/register/registerSlice'
import {setUserInfo} from 'redux/features/general/generalSlice'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useTranslate from 'hooks/useTranslate'
import VerificationInput from 'react-verification-input'
import auth from 'utils/Auth'


const PhoneVerifyModalContent = ({ modalData, setModalData }) => {

  const { showToast } = useToast()
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();


  const [codeData, setCodeData] = useState([])
  const [request] = useRequest()
  const dispatch = useDispatch()

  const [timerExpired, setTimerExpired] = useState(false);
  const {t} = useTranslate()
  const { register } = useSelector((state) => state)


  const [timerFinish, setTimerFinish] = useState()


  const handleTimeout = () => {
    setTimerExpired(true);
  };

  console.log(timerExpired, "timerExpired");



  useEffect(() => {
    if (register.registerTimer) {
      showToast("Süre Doldu!", 'error')
      setTimerFinish(register.registerTimer)
    } else {
      setTimerFinish(false)
      dispatch(setTimer(false))
    }
  }, [register]);

  const handleFinish = () => {
    if (!timerFinish) {
      request('/InternalAuth/VerifyPhone', {
        method: 'POST',
        params: {
          dataId: modalData.dataId,
          code: codeData.toString(),
        },

      }).then((res) => {
        if (res.data) {
          if (res.data.metadata) {
            showToast(res.data.metadata.message, 'error')
          }
          else if (res.data.ok == true) {
            setModalData({open:false,dataId:'',phone:''})
            showToast(t('updateInformationSuccess'),'success')
            request('/Profile', {
              method: 'GET',
            }).then((res) => {
                if (res?.data?.result) {
                    if (!res?.data?.result?.isGuest && (auth.isGuest() || sessionStorage.getItem('userChoises'))) {
                      auth.setMemberShip()
                    }
                    dispatch(setUserInfo(res.data.result))
                    if(searchParams.get('updatePayment')){
                       navigate("/odeme")
                    }
                }
            })
          }
        }
      })
    }
    else {
      request('/InternalAuth/ResendVerifyPhoneCode', {
        method: 'POST',
        params: {
          dataId: modalData.dataId,
        },

      }).then((res) => {
        if (res.data) {
          setTimerFinish(false)
          showToast("Kod Tekrar Gönderildi..", 'error')
        }
      })
    }
  }

  return (
    <div className='register-container register-container-modal'>
      <div className='register-container-stage3Img'>
        <img src={images.phone2} alt="" />
      </div>
      <div className='register-container-stage3Text'>{t('phoneCodeText',{phone:`********${modalData?.phone?.slice(-2)}`})} </div>
      <VerificationInput
        validChars="0-9" 
        inputProps={{ inputMode: "numeric" }}
        length={8}
        placeholder=''
        autoFocus={true}
        onChange={(e) =>{
          setCodeData(e)
        }}
        value={codeData}
          classNames={{
            container: "register-container-code",
            character: "character",
            characterInactive: "character--inactive",
            characterSelected: "character--selected",
          }}
        />
      <div className='register-container-timer'>{t('time')}:  <CountdownTimer minutes={5} seconds={Number(`00`)} onTimeout={handleTimeout} /></div>
      <div >
        <Button onClick={handleFinish} className={"btn-primary"} icon={''} text={timerFinish ? t('sendAgain') : t('approve')} />
      </div>
    </div>
  )
}

export default PhoneVerifyModalContent